import React from 'react';
import { Box } from '@mui/material';
import AreaTitle from '../../../components/areaTitle/AreaTitle';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import TemplateDownload from './components/TemplateDownload';
import ImportInstructions from './components/ImportInstructions';
import ProcessFlow from './components/ProcessFlow';
import ImportFAQ from './components/ImportFAQ';
import styles from './Import.module.css';

const Import = () => {
    return (
        <div className={`page-content ${styles.pageContainer}`}>
            <div className={styles.contentWrapper}>
                <div className={styles.headerContainer}>
                    <AreaTitle 
                        Title="Importar dados de pacientes" 
                        Description="Importe seus pacientes para o sistema de forma rápida e segura."
                        Icon={<UploadFileOutlinedIcon/>}
                    />
                </div>
                
                <div className={styles.sectionContainer}>
                    <TemplateDownload />
                </div>
                
                <div className={styles.sectionContainer}>
                    <ProcessFlow />
                </div>
                
                <div className={styles.sectionContainer}>
                    <ImportInstructions />
                </div>
                
                <div className={styles.sectionContainer}>
                    <ImportFAQ />
                </div>
            </div>
        </div>
    );
};

export default Import;